import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import { Link } from "react-router-dom";
import "./styles.css";

const UserJoinedGroups = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [joinedGroups, setJoinedGroups] = useState([]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        fetchUserGroups(user.uid);
      } else {
        setJoinedGroups([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchUserGroups = async (uid) => {
    try {
      const database = getDatabase();
      const userGroupsRef = ref(database, `USERS/${uid}/GROUPS`);
      const snapshot = await get(userGroupsRef);

      if (snapshot.exists()) {
        const groupsData = snapshot.val();
        const groupsList = [];

        // Convert nested structure to flat array
        for (const groupId in groupsData) {
          for (const slugKey in groupsData[groupId]) {
            groupsList.push({
              groupId,
              ...groupsData[groupId][slugKey],
            });
          }
        }

        setJoinedGroups(groupsList);
      } else {
        setJoinedGroups([]);
      }
    } catch (error) {
      console.error("Error fetching user groups:", error);
      setJoinedGroups([]);
    }
  };

  // Don't render if not logged in or no groups
  if (!currentUser || joinedGroups.length === 0) {
    return null;
  }

  return (
    <div className="event-sidebar p-4 rounded-lg">
      <div className="joined-groups-header">
        <h2>Your Groups</h2>
      </div>

      <div className="joined-groups-grid">
        {joinedGroups.map((group) => (
          <Link
            to={`/Group/${group.GROUP_SLUG}`}
            key={`${group.groupId}-${group.GROUP_SLUG}`}
            className="joined-group-card"
          >
            <div className="">
              <h3>{group.GROUP_NAME}</h3>
              <span className="event-badges mb-3">
                {group.GROUP_RANK === "OWNER"
                  ? "Owner"
                  : group.GROUP_RANK === "ADMIN"
                  ? "Admin"
                  : "Member"}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default UserJoinedGroups;
